var APP = APP || {};

APP.ajaxRequest = null;
APP.pushGaEvent = function (category, action, label) {
    if (typeof (ga) === 'function') {
        ga('send', 'event', category, action, label);
    }
};

APP.fbShare = function (link) {

    if (!link) {
        link = APP.baseUrl;
    }
    FB.ui({
        method: 'share',
        href: link
    }, function (response) {
        if (response && !response.error_code) {
            APP.pushGaEvent('share', 'share facebook', 'Social share via FB BMI');
        }
    });
};

$(document).ready(function () {
    $('.fb').click(function(){
        console.log(APP.vendorUrl);
        APP.fbShare(APP.vendorUrl);
    });

    //$(document).on('keypress', '#txtPhone', function(){
    //    if ($(this).val().length == 4 || $(this).val().length == 8){
    //        $(this).val($(this).val() + " ");
    //    }
    //});

    //console.log("test");
    var csrf = $('meta[name=csrf-token]').attr('content');
    $.ajaxSetup({
        beforeSend: function (request) {
            return request.setRequestHeader('X-CSRF-Token', csrf);
        }
    });

    $('#login-form').on('submit', function (e) {
        e.preventDefault();
        if (APP.ajaxRequest !== null) {
            APP.ajaxRequest.abort();
        }
        var $this = $(this);
        var $error = $this.find('.error');
        $error.empty().hide();

        APP.ajaxRequest = $.ajax({
            type: "POST",
            url: APP.baseUrl + 'login',
            data: $this.serialize(),
            error: function (response) {
                //console.log(response);
                //console.log(status);
                var responseJson = $.parseJSON(response.responseText);
                if (response.status == 403) {
                    $error.append(responseJson.message);
                    //console.log(responseJson.message);
                }
                else if (response.status == 422) {
                    $.each(responseJson, function (i, v) {
                        $error.append(v);
                    });
                }
                else {
                    alert('Something went wrong');
                }
                $error.show();
                $.colorbox.resize();
            },
            success: function (response, status) {
                if (response.message == 'register') {
                    // display register screen
                    //console.log(response);
                    $('#login').hide();
                    $('#main-pop').append(response.view);

                } else if (response.message == 'invite screen') {
                    // display invite screen
                    $('#login').hide();
                    $('#main-pop').append(response.view);
                } else {
                    // display Sorry page
                    $('#login').hide();
                    $('#main-pop').append(response.view);
                }
                $.colorbox.resize();
            }
        });
        APP.ajaxRequest = null;
//        return false;
    });

    $(document).on('submit', '#register-form', function (e) {
        e.preventDefault();
        if (APP.ajaxRequest !== null) {
            APP.ajaxRequest.abort();
        }
        var $this = $(this);
        var $error = $this.find('.error');
        $error.empty().hide();

        APP.ajaxRequest = $.ajax({
            type: "POST",
            url: APP.baseUrl + 'register',
            data: $this.serialize(),
            error: function (response, status) {
                //console.log(response);
                //console.log(status);
                var responseJson = $.parseJSON(response.responseText);
                if (response.status == 403) {
                    $error.append(responseJson.message);
                    //console.log(responseJson.message);
                }
                else if (response.status == 422) {
                    $error.append('| ');
                    $.each(responseJson, function (i, v) {
                        $error.append(v + ' | ');
                    });
                }
                else {
                    alert('Something went wrong');
                }
                $error.show();
                $.colorbox.resize();
            },
            success: function (response, status) {
                // display invite screen
                $('#register').remove();
                $('#main-pop').append(response.view);
                $.colorbox.resize();
            }
        });
        APP.ajaxRequest = null;
    });


	
    //$('.login').colorbox({
    //    inline: true, href: "#login", width: '475px', opacity: '0.8', closeButton: false, overlayClose:false,
		//onComplete: function () {
		//	parent.$.colorbox.resize();
		//}
    //});
    //$('.register').colorbox({
    //    inline: true, href: "#register", width: '475px', opacity: '0.8', closeButton: false, overlayClose:false,
		//onComplete: function () {
		//	parent.$.colorbox.resize();
		//}
    //});
    //$('.thankyou-invite').colorbox({
    //    inline: true, href: "#thankyou-invite", width: '475px', opacity: '0.8', closeButton: false, overlayClose:false,
		//onComplete: function () {
		//	parent.$.colorbox.resize();
		//}
    //});
    //$('.thankyou').colorbox({
    //    inline: true, href: "#thankyou", width: '475px', opacity: '0.8', closeButton: false, overlayClose:false,
		//onComplete: function () {
		//	parent.$.colorbox.resize();
		//}
    //});
    //$('.sorry').colorbox({
    //    inline: true, href: "#sorry", width: '475px', opacity: '0.8', closeButton: false, overlayClose:false,
		//onComplete: function () {
		//	parent.$.colorbox.resize();
		//}
    //});
    //$('.popup').colorbox({
    //    inline: true, href: "#main-pop", width: '475px', opacity: '0.8', closeButton: false, overlayClose:false,
    //    onComplete: function () {
    //        parent.$.colorbox.resize();
    //    }
    //});
	
	

    $(document).on('click', '.no-thankyou', function(){
        location.reload();
    });
	
	$('.tools article').on('click', function() {
	  if ($(this).hasClass("today")) {	  
		$(this).find('.product').show();
		$(this).find('.front').hide();
		$('#day-count').text($(this).data('day'));
		setTimeout(function() {
			$.colorbox({
				inline: true, href: "#main-pop", width: '475px', maxWidth:'90%', opacity: '0.8', closeButton: false, overlayClose:false,
				onComplete: function () {
					parent.$.colorbox.resize();
				}
			})
		}, 1000);
	  }
	});
	
	$(document).on('click', '.terms', function(){
		$.colorbox({
			inline: true, href: "#tnc-page", width: '700px', maxWidth:'90%', height: '600px', maxHeight:'90%', top: '10%', opacity: '0.8', closeButton: false, overlayClose:false
		});
	});
	$(document).on('click', '.close', function(){
        $.colorbox.close();
	});
    $(document).on('click', '.close-tnc', function(){
        $.colorbox({
            inline: true, href: "#main-pop", width: '475px', maxWidth:'90%', opacity: '0.8', closeButton: false, overlayClose:false,
            onComplete: function () {
                parent.$.colorbox.resize();
            }
        });
    });
});

function captureTweet(event) {
    if (event.type === 'tweet') {
        //ga capture tweet success
        APP.pushGaEvent('share', 'share twitter', 'Social share via TW BMI');

    }
}
